import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { IConfiguracionLLaves } from '../../../../shared/interfaces/database/configuracion';

export interface LlavesOptions {
  data: any[];
  optionLabel: string;
  optionValue: string;
  headerText: string;
  disable?: boolean;
}

@Component({
  selector: 'app-configuracion-llaves',
  standalone: true,
  imports: [DropdownModule, ButtonModule, TableModule,
    FormsModule, TooltipModule, CommonModule,
    TranslateModule],
  template: `
    <div class="flex flex-column gap-2 w-full" *ngIf="keyOptions && valueOptions">
      <div class="flex justify-content-between align-items-center mb-2">
        <label class="ml-3 font-bold">
            {{ headerTitle || ('msg.configuracionLlaves' | translate) }}
        </label>
        <button pButton type="button" icon="pi pi-plus" [outlined]="true" *ngIf="showAdd"
          iconPos="left" class="p-button-primary w-4rem" (click)="addNew()"></button>
      </div>
      <div>
        <p-table [value]="llaves" [tableStyle]="{'min-width': '50rem'}" [scrollable]="true">
          <ng-template pTemplate="header">
            <tr>
              <th class="text-left color-blue-2 font-13 font-bold">{{keyOptions.headerText}}</th>
              <th class="text-left color-blue-2 font-13 font-bold">{{valueOptions.headerText}}</th>
              <th class="text-left color-blue-2 font-13 font-bold" style="width: 5rem" *ngIf="showDelete"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr [ngClass]="{'invalid-row': !isRowValid(rowData)}">
              <td>
                <p-dropdown [options]="keyOptions.data" appendTo="body" 
                  [optionLabel]="keyOptions.optionLabel" [optionValue]="keyOptions.optionValue"
                  [filter]="true"
                  [(ngModel)]="rowData.name" styleClass="w-full"></p-dropdown>
              </td>
              <td>
                <p-dropdown [options]="valueOptions.data" appendTo="body"
                  [optionLabel]="valueOptions.optionLabel" [optionValue]="valueOptions.optionValue"
                  [filter]="true"
                  [(ngModel)]="rowData.value" styleClass="w-full"></p-dropdown>
              </td>
              <td *ngIf="showDelete">
                <button pButton type="button" icon="pi pi-trash" class="p-button-danger" 
                  (click)="remove(rowData)" pTooltip="Eliminar" tooltipPosition="top"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="text-center p-4">
                {{'msg.noHayConfiguracionLlaves' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  `,
  styles: [`
    .invalid-row {
      background-color: rgba(151, 0, 0, 0.05);
    }
  `]
})
export class ConfiguracionLlavesComponent {

  @Input() showDelete: boolean = true;
  @Input() showAdd: boolean = true;
  @Input() headerTitle: string = '';
  @Input() id: string = '';//esto solo es para poder encontrar el control en el caso de que hallan multiples instancias

  llaves: IConfiguracionLLaves[] = [];
  keyOptions!: LlavesOptions;
  valueOptions!: LlavesOptions;

  loadOptions(keys: LlavesOptions, values: LlavesOptions) {
    this.keyOptions = keys;
    this.valueOptions = values;
  }

  getValues(): IConfiguracionLLaves[] | null {
    if (!this.llaves || this.llaves.length === 0) {
      return null;
    }
    return this.llaves;
  }

  //#region Table Operations
  reset() {
    this.llaves = [];
  }

  load(data: IConfiguracionLLaves[]) {
    this.llaves = data;
  }

  addNew(): IConfiguracionLLaves {
    const newItem = { value: '', name: '' } as IConfiguracionLLaves;
    this.llaves.push(newItem);
    return newItem;
  }

  remove(rowData: IConfiguracionLLaves) {
    if (!this.showDelete) {
      return
    }
    this.llaves = this.llaves.filter((item) => item !== rowData);
  }
  //#endregion Table Operations

  //#region Validations
  isRowValid(rowData: IConfiguracionLLaves): boolean {
    return rowData.value != '' && rowData.name != '';
  }

  isValid(): boolean {
    return this.llaves.length > 0 && this.llaves.every(item => this.isRowValid(item));
  }
  //#endregion Validations
}
